module.exports = __webpack_public_path__ + "static/media/get_linkedin_connections.d2da4bb1.svg";